export enum UiElementType
{
    None = 0,
    Text = 1,
    YesNo = 2,
    Date = 3,
    DateTime = 4,
    Number = 5,
    InputEvent = 6,
    Button = 7,
    MessageBox = 8,
    Label = 9,
    Dropdown = 10,
    ClearScreen = 11,
    GlobalKeyDown = 12,
    Info = 13,
    Grid = 14,
}


// WEBPACK FOOTER //
// C:/git/flowdesigner/src/classes/UIElementType.ts